import type { WordModule } from '@faker-js/faker';
import { faker } from '@faker-js/faker';

type Count = number | { min: number; max: number };

export const apiKey = () => faker.string.alphanumeric(20);
export const arrayOf = <T>(createItem: () => T, countOption: Count = 10) =>
  faker.helpers.multiple(() => createItem(), { count: countOption });
export const boolean = () => Math.random() > 0.5;
export const color = () => faker.color.rgb();
export const comment = (options?: Parameters<WordModule['words']>[0]) => faker.word.words(options);
export const count = (countOption: Count = 10) => faker.number.int(countOption);
export const description = () => faker.lorem.sentence();
export const email = () => faker.internet.email();
export const filePath = () => faker.system.filePath();
export const firstName = () => faker.person.firstName();
export const float = () => faker.number.float(10);
export const icon = () => faker.helpers.arrayElement(['flag', 'fingerprint', 'chart-venn'] as const);
export const id = () => faker.string.uuid();
export const imageUrl = () => faker.image.url();
export const integer = (options?: Parameters<typeof faker.number.int>[0]) => faker.number.int(options);
export const key = () => arrayOf(() => faker.animal.type(), 3).join('-');
export const lastName = () => faker.person.lastName();
export const link = () => ({ href: faker.internet.url(), type: 'application/json' });
export const links = () => ({ self: link() });
export const name = () => faker.word.words(2);
export const number = () => (boolean() ? integer() : float());
export const oneOf = <T>(options: T[]) => options[faker.number.int(options.length - 1)];
export const optional = <T>(callback: () => T) => faker.helpers.maybe(callback);
export const pastDate = (refDate?: string | Date | number) => faker.date.past({ refDate }).getTime();
export const pastDateISO = (refDate?: string | Date | number) => faker.date.past({ refDate }).toISOString();
export const string = () => faker.string.alpha(10);
export const stringEnum = <const T extends string[]>(options: T) => faker.helpers.arrayElement(options) as T[number];
export const word = () => faker.word.noun();
